import { render, staticRenderFns } from "./search-person.vue?vue&type=template&id=7a8cd11c&scoped=true"
import script from "./search-person.vue?vue&type=script&lang=js"
export * from "./search-person.vue?vue&type=script&lang=js"
import style0 from "./search-person.vue?vue&type=style&index=0&id=7a8cd11c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8cd11c",
  null
  
)

export default component.exports